var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('transition',{attrs:{"name":"fade"}},[(_vm.isLoading)?_c('preLoading'):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }